import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero-section">
        <Container>
          <div className="hero-content text-center">
            <h1 className="hero-title">
              Building India's Infrastructure
              <span className="text-gradient d-block mt-2">With Excellence</span>
            </h1>
            <p className="hero-subtitle">
              Leading provider of Underground Cable Wiring, Road Construction,
              Electricity Meters Installation & Infrastructure Solutions
            </p>
            <div className="hero-buttons d-flex gap-3 justify-content-center flex-wrap">
              <Button as={Link} to="/services" variant="primary" size="lg">
                Explore Services
              </Button>
              <Button as={Link} to="/contact" variant="outline" size="lg">
                Get Free Quote
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Home;